import { applicationConfiguration } from '@/api/abp'
const state = {
  abpConfig: null,
  active:0,
  loading:false,
}

const mutations = {
  SET_ABPCONFIG: (state, abpConfig) => {
    state.abpConfig = abpConfig
  },
  SET_ACTIVE:(state,active)=>{
    state.active = active;
  },
  SET_LOADING:(state,loading)=>{
    console.log(loading);
    state.loading = loading;
  }
}

const actions = {
  applicationConfiguration({ commit }) {
    return new Promise((resolve, reject) => {
      applicationConfiguration()
        .then(response => {
          commit('SET_ABPCONFIG', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setActive({commit},value){
    commit('SET_ACTIVE',value);
  },
  setLoading({commit},value){
    commit('SET_LOADING',value);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
